function psMagnifyClosestImage(target) {
  while (target && target.nodeType === 1) {
    if (target.className && (' ' + target.className + ' ').indexOf(' image-magnify-hover ') > -1) {
      return target;
    }
    target = target.parentNode;
  }
  return null;
}

function psCreateMagnifyOverlay(image) {
  var overlayImage = document.createElement('img');
  var overlay = document.createElement('div');
  var imageParent = image.parentElement;
  var overlayParent = imageParent;
  var insertBeforeNode = image;

  overlayImage.setAttribute('src', image.currentSrc || image.src);
  psPrepareMagnifyOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  psToggleMagnifyLoadingSpinner(image);

  overlayImage.onload = function () {
    psToggleMagnifyLoadingSpinner(image);
    if (imageParent && imageParent.nodeName === 'PICTURE' && imageParent.parentElement) {
      overlayParent = imageParent.parentElement;
      insertBeforeNode = imageParent;
    }
    overlayParent.insertBefore(overlay, insertBeforeNode);
    image.style.opacity = '100%';
  };

  return overlay;
}

function psPrepareMagnifyOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = "url('" + image.src + "')";
  container.style.backgroundColor = 'var(--gradient-background)';
}

function psToggleMagnifyLoadingSpinner(image) {
  var container = image.parentElement;
  var loadingSpinner;

  while (container && container.nodeType === 1 && (' ' + container.className + ' ').indexOf(' product__modal-opener ') < 0) {
    container = container.parentElement;
  }

  loadingSpinner = container ? container.querySelector('.loading__spinner') : null;

  if (loadingSpinner) {
    loadingSpinner.classList.toggle('hidden');
  }
}

function psMoveMagnifyWithHover(image, overlay, event, zoomRatio) {
  var ratio = image.height / image.width;
  var container = event.target.getBoundingClientRect();
  var xPosition = event.clientX - container.left;
  var yPosition = event.clientY - container.top;
  var xPercent = xPosition / (image.clientWidth / 100) + '%';
  var yPercent = yPosition / ((image.clientWidth * ratio) / 100) + '%';

  overlay.style.backgroundPosition = xPercent + ' ' + yPercent;
  overlay.style.backgroundSize = image.width * zoomRatio + 'px';
}

function psMagnifyImage(image, event, zoomRatio) {
  var overlay = psCreateMagnifyOverlay(image);

  overlay.onclick = function () {
    overlay.remove();
  };
  overlay.onmousemove = function (moveEvent) {
    psMoveMagnifyWithHover(image, overlay, moveEvent, zoomRatio);
  };
  overlay.onmouseleave = function () {
    overlay.remove();
  };
  psMoveMagnifyWithHover(image, overlay, event, zoomRatio);
}

function psEnableZoomOnHover(zoomRatio) {
  document.addEventListener('click', function (event) {
    var image = psMagnifyClosestImage(event.target);

    if (!image) {
      return;
    }

    psMagnifyImage(image, event, zoomRatio);
  });
}

psEnableZoomOnHover(2);
